import { BaseModel } from "model/BaseModel";
import GrupoUsuariosUsuario from "./GrupoUsuariosUsuario";


export default class GrupoUsuarios implements BaseModel {
    id: number;
    codigo = null;
    nome: string;
    itens: GrupoUsuariosUsuario[] = [];
    constructor(
        id: number = 0,
        nome: string = "",
    ) {
        this.id = id;
        this.nome = nome;
    }
}